import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';
import { CloudActions } from 'reactApp/constants/cloudActions';

export class PrivateListAPICall extends APICallV4 {
    _method = 'private/list';
    _type: Method = 'get';
    _headers = { 'X-VFS-Action': CloudActions.FOLDER_LIST };
}
